module.exports = __webpack_public_path__ + "static/ui-ux-design-06a22319202a526fcfcc6f62aa2d5775.png";